/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TWFee, TWFeeInterface } from "../TWFee";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
      {
        internalType: "address",
        name: "_factory",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tierId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "feeType",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bps",
        type: "uint256",
      },
    ],
    name: "FeeTierUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "proxyOrDeployer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tierId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "validUntilTimestamp",
        type: "uint256",
      },
    ],
    name: "TierUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_FEE_BPS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "contract TWFactory",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "feeInfo",
    outputs: [
      {
        internalType: "uint256",
        name: "bps",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_proxy",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_feeType",
        type: "uint256",
      },
    ],
    name: "getFeeInfo",
    outputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "bps",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_deployer",
        type: "address",
      },
      {
        internalType: "address",
        name: "_proxy",
        type: "address",
      },
    ],
    name: "getFeeTier",
    outputs: [
      {
        internalType: "uint128",
        name: "tierId",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "validUntilTimestamp",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tierId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_feeBps",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_feeRecipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_feeType",
        type: "uint256",
      },
    ],
    name: "setFeeInfoForTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_extension",
        type: "address",
      },
    ],
    name: "setFeeTierPlacementExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_proxyOrDeployer",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_tierId",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "_validUntilTimestamp",
        type: "uint128",
      },
    ],
    name: "setTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tierPlacementExtension",
    outputs: [
      {
        internalType: "contract IFeeTierPlacementExtension",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type TWFeeConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TWFeeConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TWFee__factory extends ContractFactory {
  constructor(...args: TWFeeConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "TWFee";
  }

  deploy(
    _trustedForwarder: string,
    _factory: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TWFee> {
    return super.deploy(
      _trustedForwarder,
      _factory,
      overrides || {}
    ) as Promise<TWFee>;
  }
  getDeployTransaction(
    _trustedForwarder: string,
    _factory: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _trustedForwarder,
      _factory,
      overrides || {}
    );
  }
  attach(address: string): TWFee {
    return super.attach(address) as TWFee;
  }
  connect(signer: Signer): TWFee__factory {
    return super.connect(signer) as TWFee__factory;
  }
  static readonly contractName: "TWFee";
  public readonly contractName: "TWFee";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TWFeeInterface {
    return new utils.Interface(_abi) as TWFeeInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): TWFee {
    return new Contract(address, _abi, signerOrProvider) as TWFee;
  }
}
